import React from 'react'
import ReactGA from 'react-ga'

export default class extends React.Component {
    componentDidMount(){

        let path = this.props.path || location.pathname
        if(this.props.hash) path += '#'+this.props.hash
        ReactGA.pageview(path)
    }

    render() {return null}
}


// WEBPACK FOOTER //
// ./src/components/pageview-ga.js